import React from "react";
import { useIntl } from "react-intl";
import { ReactSVG } from "react-svg";
import questionMarkIcon from '../../../../../../assets/images/layout/question-mark-icon.svg'

const QuestionMark = ({ onClick }) => {
    const intl = useIntl();
    return (
        <button type="button" aria-label={intl.formatMessage({ id: "teamroom.support.title" })} className="relative cursor-pointer rounded-full" onClick={onClick}>
            <ReactSVG
                src={questionMarkIcon}
                className="text-standart-ocean hover:text-light-purple active:text-black"
            />
        </button>
    );
};

export default QuestionMark;
